export default {
  handleDocumentContainer: {
    title: 'Attach an estimate',
    text: 'Present us with a quote from a craftsman of your choice. This will be reviewed by our technical team who will validate it or contact you if necessary.',
    billmaSolution: {
      title: 'Property damages',
      solution: 'Solution: Choose my own craftsman',
      text1: 'Now attach your craftsman’s estimate for analysis.',
      text2: 'By submitting your documents, you agree that they will be analyzed manually or by an algorithm.',
      text3: 'Estimate:',
      uploadBtn: 'Add a document'
    },
    actions: {
      primary: 'Continue'
    },
    documentUploadStep: {
      actions: {
        primary: 'Attach the document'
      }
    },
    icrModal: {
      title: 'Uploading files',
      text1: 'The files are currently being processed. Please continue to wait.',
      text2: 'The process may take a few minutes.',
      text3: 'We are processing your documents. In a few minutes we will validate your compensation.'
    },
    deleteModal: {
      title: 'Delete the document?',
      text: 'The document “{name}” will be deleted and will not be sent for analysis.',
      confirm: 'Delete',
      cancel: 'Cancel',
      error: 'The document could not be deleted. Please try again.'
    }
  }
}
